import { useParams } from 'react-router-dom';

import KpiDefinitionForm from './KpiDefinitionForm';

export default function EditKpiDefinitionPage() {
  const { kpiDefinitionId } = useParams<{
    kpiDefinitionId: string;
  }>();

  return <KpiDefinitionForm definitionId={kpiDefinitionId} />;
}
